import useMutate from "~/hooks/useMutateApi";

export interface RequestProps {
  phone_number: string;
}

export interface ResponseProps {
  created: boolean;
}

export enum DeliveryEnum {
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}

const useSendPhoneCode = () =>
  useMutate<ResponseProps, RequestProps>("/users/me/verify-code/phone-number/", { method: "POST" });

const useRequestVerifyCode = () => useMutate("/users/verify", { method: "POST" });

export { useSendPhoneCode, useRequestVerifyCode };
